import React from "react";
import "./FaceWaxing.css";
const FaceWaxing = () => {
  return (
    <div className="faceWaxingContainer">
      <h2>Face Waxing at SCENT</h2>
      <h3>Smooth and Flawless Skin</h3>
      <p>
        Face waxing is a popular method for{" "}
        <a href="https://scentlifestyle.com/beauty-essentials">removing unwanted facial hair</a>, leaving your skin smooth
        and flawless. At SCENT, we use high-quality waxes that are gentle on the
        skin, ensuring a comfortable and effective waxing experience.
      </p>
      <h3>Benefits of Face Waxing</h3>
      <li>
        <h6>Long-lasting Results:</h6> Unlike shaving, which only removes hair
        at the surface, waxing removes hair from the root. This means your skin
        stays smooth for longer.
      </li>
      <li>
        <h6> Reduced Hair Growth:</h6> Regular waxing can lead to finer and
        sparser hair growth over time.
      </li>
      <li>
        <h6>Exfoliation:</h6> Waxing also exfoliates the skin, removing dead
        skin cells and leaving your complexion brighter and more radiant.{" "}
      </li>
      <h3>Our Face Waxing Process</h3>
      <li>
        <h6>1. Consultation</h6>We begin with a thorough consultation to
        understand your skin type and any sensitivities.
      </li>
      <li>
        <h6>2. Preparation:</h6> Your skin is cleansed and prepped to ensure
        optimal results.
      </li>
      <li>
        <h6>3. Waxing:</h6> We apply the wax and remove it with precision,
        minimizing discomfort and ensuring all unwanted hair is removed.
      </li>
      <li>
        <h6>4. Aftercare::</h6> Post-waxing, we apply soothing products to calm
        the skin and prevent irritation.
      </li>
    </div>
  );
};

export default FaceWaxing;
